/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Connected from './Connected/index'
import Disconnected from './Disconnected/index'
import Error from './Error/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App/Status"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appValueData = fromData.useDataValue({ viewPath,
context: 'app',
})
let tabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
})
let aggregateData = fromHelpers.getView(appValueData, tabValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Connected'}>
<Connected
  viewPath={`${viewPath}/Connected`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Disconnected'}>
<Disconnected
  viewPath={`${viewPath}/Disconnected`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}